(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* TR-WOS: in-stock-only toggle pill - filters product cards via data-tr-in-stock attribute */
  (function(){
    const STORAGE_KEY = 'tr_in_stock_only';
    function init(){
      const buttons = document.querySelectorAll('[data-tr-stock-toggle]');
      const list = document.querySelector('results-list');
      if(!buttons.length || !list) return;
      const apply = (on) => {
        list.classList.toggle('tr-in-stock-only', on);
        buttons.forEach(b => {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('tr-stock-toggle--active', on);
        });
      };
      try { apply(localStorage.getItem(STORAGE_KEY) === '1'); } catch(e){}
      buttons.forEach(b => {
        if(b.dataset.trBound === '1') return;
        b.dataset.trBound = '1';
        b.addEventListener('click', () => {
          const next = b.getAttribute('aria-pressed') !== 'true';
          apply(next);
          try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch(e){}
        });
      });
    }
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
